
import { useEffect } from "react"
import { Form, Space} from "antd"
import { useSelector, useDispatch } from "react-redux"
import { MyInput } from "../../../Forms"
import { actionsApi } from "../../../../shared"
let timer

const Filter= ({form})=>{
    const {pagination} = useSelector(state => state?.boxManagementGo)
    const dispatch= useDispatch()

    useEffect(()=>{
        dispatch(actionsApi?.viewAllAndroidBoxesGo({pageNo: 1, pageSize: pagination?.pageSize}))
    },[])

    const filter = () => {
        let data = form.getFieldsValue()
        dispatch(actionsApi?.viewAllAndroidBoxesGo({ ...data, ...pagination}))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(filter, 400)

    return (
        <>
            <Form
                form={form}
                layout="vertical"
            >
                <Space className='align-center'>
                    <MyInput
                        size='large'
                        name='serialNo'
                        label='Serial no'
                        placeholder='e.g Box1002'
                        style={{width: '220px'}}
                        onChange={debouncedSearchHandler}
                    />
                </Space>
            </Form>
        </>
    )
}
export {Filter}